export default __webpack_public_path__ + "static/media/avatar_tommy4.54198c8e.mp3";